import React, { useCallback, useState } from 'react';

import styles from './resumePhoneStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';
import Modal from 'buyside/components/presentation/Modal/modal';

import { getFilepathExtension } from 'buyside/util/fileHelper';

const ResumePhone = ({ userProfile }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const resume = JSON.parse(userProfile.resume);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.viewResumeLink}
        onClick={() => setIsModalOpen(true)}
        text="View your resume"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <ul className={styles.resumePhoneList}>
      {resume && (
        <li>
          <h4>Resume</h4>
          {getFilepathExtension(resume.filename) === 'pdf' ? (
            <Modal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              renderOpenModalButton={renderOpenModalButton}
              size="xl"
              title="Your Resume"
            >
              <object
                data={resume.url}
                type="application/pdf"
                width="100%"
                style={{ height: '70vh' }}
              >
                <p>
                  This browser does not support inline PDFs.&nbsp;
                  <Link to={resume.url} target="_blank">
                    Click here
                  </Link>
                  &nbsp;to view your resume.
                </p>
              </object>
            </Modal>
          ) : (
            <Link className={styles.viewResumeLink} to={resume.url}>
              Download your resume
            </Link>
          )}
        </li>
      )}
      <li>
        <h4>Phone</h4>
        <span>{userProfile.workPhone}</span>
      </li>
    </ul>
  );
};

export default ResumePhone;
